import whatsapp from "../../images/iconowhatsapp.svg";

export const WhatsappLogo = () => {
  return (
    <a
      href="https://api.whatsapp.com/send/?phone=5491126726707&text&type=phone_number&app_absent=0"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group hover:scale-105 transition-transform duration-300"
      aria-label="Chatear por WhatsApp"
    >
      <div className="relative flex justify-center items-center bg-[#25D366] shadow-[0_4px_20px_rgba(37,211,102,0.4)] hover:shadow-[0_8px_30px_rgba(37,211,102,0.6)] rounded-full w-14 h-14 border border-white/30 backdrop-blur-md">
        <img src={whatsapp} alt="WhatsApp" className="w-8 h-8 relative z-10 filter drop-shadow-sm" />
      </div>
    </a>
  );
};